import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';
import {useHistory, useParams} from 'react-router-dom';

import {BackTo} from 'components/common/BackTo';
import {Page} from 'components/common/Page';
import {PermissionAccess} from 'components/common/PermissionAccess';
import {Back, Container} from 'components/pages/NotFound/styled';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {Title} from 'components/ui-kit/Title';
import {ROUTE} from 'core/routes';
import {commonDataState$, DocumentsDetailGate} from 'models/documents/details';

import {UserPermission} from 'types';

import {Aggregate} from './Aggregate';
import {DropOut} from './DropOut';
import {Introduce} from './Introduce';
import {UPD} from './UPD';
import {Utilization} from './Utilization';

export const DocumentsDetailsRouter = () => {
    const {id}: {id: string} = useParams();
    const {t} = useTranslation();
    const {data, isLoading} = useStore(commonDataState$);
    const history = useHistory();

    return (
        <Page title={t('pages.documents.documents.gridName')}>
            <DocumentsDetailGate id={id} />
            <PermissionAccess
                permissions={[
                    UserPermission.PRODUCT_GRID_VIEW,
                    UserPermission.ALL_PRODUCT_GRID_VIEW,
                ]}
            >
                <BackTo to={ROUTE.DOCUMENTS_DOCUMENTS}>{t('pages.documents.back')}</BackTo>
            </PermissionAccess>
            <ContentContainer status={isLoading ? 'loading' : 'default'}>
                {data?.reportType === 'DROPOUT' && <DropOut data={data} />}
                {data?.reportType === 'AGGREGATE' && <Aggregate data={data} />}
                {data?.reportType === 'UTILISATION' && <Utilization data={data} />}
                {data?.reportType === 'INTRODUCE' && <Introduce data={data} />}
                {data?.reportType === 'UPD' && <UPD data={data} />}
                {!data && !isLoading && (
                    <Container>
                        <Title size={2}>{t('errors.tryMessage')}</Title>
                        <Back onClick={history.goBack}>{t('errors.goBack')}</Back>
                    </Container>
                )}
            </ContentContainer>
        </Page>
    );
};
